import styled from "styled-components";

export const Container = styled.article`
  width: 100%;
  display:flex;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
    
    .comment-image{
     
      img{
        width: 80px;
        border-radius: 50%;
        margin-top: var(--spacing-medium);
        margin-left: var(--spacing-medium);
        
      }   
    }
    
    .comment-body{
      display:flex;
      flex-direction:column;
      justify-content:space-between;
      width: 75%;
      margin-left: var(--spacing-small);
    
      .comment-body_title{
        display:flex;
        align-items: center;
        h4{
          font-family: Avenir-Heavy;
          font-size: 16px;
          color: #4A4A49;
          letter-spacing: -0.38px;
          margin-right:var(--spacing-very-small);
        }
        div{
           margin-left: var(--spacing-small);
          font-family: Avenir-Medium;
          font-size: 14px;
          color: #7F7F7F;
          letter-spacing: 0;
        }
        .comment-title_icon{
          margin-left: auto;
        }
      }
    
      .comment-body_text{
        margin: var(--spacing-small) 0;
        font-size: 12px;
      font-weight: normal;
      }
    
      .comment-body_action{
          display:flex;
          align-items:center;
          position: relative;
          margin: var(--spacing-very-small) 0;
          .action-icon{
            display:flex;
            justify-content: flex-end;
            img{
              margin-right:5px;
            }
          }
          a{
            margin-right:var(--spacing-small);
          }
    
          a:last-of-type{
            margin-right:0;
          }
    
          .comment-edit::before{
            content: "";
            background: var(--color-third);
            position: absolute;
            left: -10px;
            height: 85%;
            width: 2px;

          }
    
          .comment-edit{
            padding: 0 var(--spacing-very-small);
            margin: 0 var(--spacing-small);
            position: relative;

          }
    
          .comment-chevron{
            margin-left:auto;
          }
      }
    }
`;
